export class CreateAbscond{
    associateId: number;
    absentFromDate: string;
    absentToDate: string;
    tlId: number;
    remarksByTL: string;
    remarksByHRA: string;
    remarksByHRM: string;
    isAbscond: boolean;
}